import defaultSettings from '@/settings';
var title = defaultSettings.title || process.env.VUE_APP_HOME_TITLE;
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}